import { render, staticRenderFns } from "./ListDiseases.vue?vue&type=template&id=5390f748&scoped=true"
import script from "./ListDiseases.vue?vue&type=script&lang=js"
export * from "./ListDiseases.vue?vue&type=script&lang=js"
import style0 from "./ListDiseases.vue?vue&type=style&index=0&id=5390f748&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5390f748",
  null
  
)

export default component.exports